function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 0H3a3 3 0 00-3 3v15.5a3 3 0 003 3h6.5a1 1 0 000-2H3a1 1 0 01-1-1V5.251A.25.25 0 012.249 5H21.75a.25.25 0 01.25.25v5.25a1 1 0 002 0V3a3 3 0 00-3-3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.96 19.43a.846.846 0 00-1.076.527v.001a3.462 3.462 0 01-5.854 1.2.212.212 0 01.007-.291l1.457-1.456a.423.423 0 00-.3-.722h-3.77a.423.423 0 00-.424.423v3.771a.423.423 0 00.723.3l.82-.821a.212.212 0 01.299 0l.004.005a5.15 5.15 0 008.64-1.862.846.846 0 00-.527-1.074zM23.739 13.654a.423.423 0 00-.462.092l-.868.869a.21.21 0 01-.151.061.214.214 0 01-.15-.065 5.162 5.162 0 00-8.632 1.884.847.847 0 001.602.548 3.462 3.462 0 015.839-1.223.213.213 0 01-.005.294l-1.405 1.404a.423.423 0 00.299.721h3.77a.423.423 0 00.424-.423v-3.77a.423.423 0 00-.261-.392z"
});

function SvgSpMenuAppUnsynced(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "spMenuAppUnsynced.3af4e.svg";
export { SvgSpMenuAppUnsynced as ReactComponent };